const BeachIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-5 h-5"
  >
    <path d="M8 17l4-4 4 4" />
    <path d="M2 22l20-20" />
    <path d="M16 8l-4 4-4-4" />
    <path d="M3 21c3.5-3.5 7-7 10.5-10.5" />
  </svg>
)

export default BeachIcon
